import { FC } from "react";

import { Button } from "@src/lib/ui/Button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@src/lib/ui/Tooltip";
import UTurnToLeftOutlineIcon from "@src/lib/icons/18px/u-turn-to-left-outline";
import UTurnRightArrowIcon from "@src/lib/icons/18px/u-turn-right-arrow";

type Props = {
  undo: () => void;
  redo: () => void;
  undoCount: number;
  redoCount: number;
};

const UndoRedoButtons: FC<Props> = ({ undo, redo, undoCount, redoCount }) => (
  <div className="flex items-center gap-0.5">
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-md"
          disabled={undoCount === 0}
          onClick={undo}
          aria-label="Undo"
        >
          <UTurnToLeftOutlineIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" hidden={undoCount === 0}>
        {`Undo (${undoCount})`}
      </TooltipContent>
    </Tooltip>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-md"
          disabled={redoCount === 0}
          onClick={redo}
          aria-label="Redo"
        >
          <UTurnRightArrowIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" hidden={redoCount === 0}>
        {`Redo (${redoCount})`}
      </TooltipContent>
    </Tooltip>
  </div>
);

export default UndoRedoButtons;
